import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Logo and Description */}
          <div className="space-y-4">
            <Link to="/" className="block">
              <img 
                src="/logo-carmaintenance.svg" 
                alt="CarMaintenance" 
                className="h-auto w-full max-w-[220px] brightness-0 invert"
              />
            </Link>
            <p className="text-gray-400 text-sm">
              L'abonnement qui révolutionne l'entretien automobile en Suisse.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-lg">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/abonnements" className="text-gray-400 hover:text-[#52a675] transition-colors">
                  Abonnements
                </Link>
              </li>
              <li>
                <Link to="/nos-partenaires" className="text-gray-400 hover:text-[#52a675] transition-colors">
                  Nos garages
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-[#52a675] transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/a-propos-de-nous" className="text-gray-400 hover:text-[#52a675] transition-colors">
                  Le projet
                </Link>
              </li>
              <li>
                <Link to="/mon-abonnement" className="text-gray-400 hover:text-[#52a675] transition-colors" data-testid="footer-mon-abonnement-link">
                  Mon abonnement
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-4 text-lg">Légal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/cgv" className="text-gray-400 hover:text-[#52a675] transition-colors">
                  Conditions Générales
                </Link>
              </li>
              <li>
                <Link to="/protection-donnees" className="text-gray-400 hover:text-[#52a675] transition-colors">
                  Protection des Données
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="text-gray-400 hover:text-[#52a675] transition-colors">
                  Mentions Légales
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-lg">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-gray-400">
                <Mail className="w-4 h-4" />
                <a href="mailto:info@car-main.ch" className="text-sm hover:text-[#52a675]">
                  info@car-main.ch
                </a>
              </li>
              <li className="flex items-center space-x-2 text-gray-400">
                <Phone className="w-4 h-4" />
                <a href="tel:0229809393" className="text-sm hover:text-[#52a675]">
                  022 980 93 93
                </a>
              </li>
              <li className="flex items-center space-x-2 text-gray-400">
                <MapPin className="w-4 h-4" />
                <span className="text-sm">Rue des Lattes 62, 1217 Meyrin</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © CarMaintenance — {new Date().getFullYear()}. Tous droits réservés.
            </p>
            
            {/* Social Media */}
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/share/1HAkFz5kT8/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#52a675] transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/carmaintenancech/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#52a675] transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/car-main/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#52a675] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
